export default __webpack_public_path__ + "static/media/YAS0220.34I-22780_-15206_0.20d1408d.jpg";